import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { Role } from '../main/models/role-model';
import RedirectPage from '../main/pages/redirect-page';

const RankingPage = React.lazy(() => import('../dashboard/pages/ranking-page'));

export const dashboardRoutePaths = {
  ranking: '/dashboard/classificacao',
  dashboard: '/dashboard',
} as const;

export const dashboardRoutes: Sebrae.RoutesConfig = [
  {
    routePath: dashboardRoutePaths.ranking,
    pageToRender: <RedirectPage route={dashboardRoutePaths.dashboard} />,
    orRedirectTo: dashboardRoutePaths.dashboard,
  },
  {
    routePath: dashboardRoutePaths.dashboard,
    ifHaveTheseRoles: [Role.admin, Role.stateManager],
    pageToRender: <RankingPage />,
  },
];
